var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationcomponent = function SvgLocationcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.321 5.75A5.246 5.246 0 0 1 5.571.5a5.246 5.246 0 0 1 5.25 5.25c0 3.938-5.25 9.75-5.25 9.75S.321 9.687.321 5.75Zm3.375 0a1.876 1.876 0 1 0 3.752-.001 1.876 1.876 0 0 0-3.752.001Z",
    fill: "current"
  })));
};
export default SvgLocationcomponent;